// A plain left click follows a header link in the page. Any modifier (Ctrl/Cmd
// for a new tab, Shift for a new window, Alt to download) or another button is
// left to the browser.

export function isPlainLeftClick(event) {
	return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
}
